/**
 * Chassis specifications and per-chassis weapon loadouts.
 */
import { G } from '../sim/state.js';

export const componentNames = [
  'head',
  'core',
  'leftTorso',
  'rightTorso',
  'leftArm',
  'rightArm',
  'leftLeg',
  'rightLeg',
];

export const chassisSpecs = {
  kestrel: {
    name: 'KESTREL',
    code: 'KST—40',
    role: 'SCOUT',
    tons: 40,
    speed: 32.2,
    accel: 8.4,
    brake: 12,
    turn: 1.05,
    eye: 10.2,
    armor: 0.72,
    cooling: 1.17,
    ammo: 0.75,
    missiles: 0.65,
    jumpAccel: 32,
    jumpSpeed: 18,
    fuelUse: 22,
    fuelRegen: 25,
    jetHeat: 9,
    maxAlt: 80,
    lockTime: 0.9,
    previewScale: 1.13,
    radius: 4.8,
    volley: 2,
    step: 0.76,
    desc: 'Light armor. Fast turns and long jumps. Two-missile volleys. Use speed and cover to stay alive.',
    weapons: [
      { name: 'TWIN PULSE', heat: 13, damage: 31, cooldown: 0.68, range: 780 },
      { name: 'LIGHT COIL', heat: 7, damage: 46, cooldown: 1.4, range: 1050 },
      { name: 'MISSILE / 2', heat: 13, damage: 21, cooldown: 3.0, range: 1150 },
    ],
  },
  warden: {
    name: 'WARDEN',
    code: 'WRD—70',
    role: 'HEAVY',
    tons: 70,
    speed: 22.2,
    accel: 5.8,
    brake: 8,
    turn: 0.7,
    eye: 13,
    armor: 1,
    cooling: 1,
    ammo: 1,
    missiles: 1,
    jumpAccel: 26,
    jumpSpeed: 15,
    fuelUse: 30,
    fuelRegen: 19,
    jetHeat: 12,
    maxAlt: 65,
    lockTime: 1.25,
    previewScale: 1.34,
    radius: 6,
    volley: 4,
    step: 1,
    desc: 'Balanced armor and firepower. Four-missile volleys. Standard jump jets. A stable choice for all three sectors.',
    weapons: [
      { name: 'DUAL PULSE', heat: 17, damage: 38, cooldown: 0.84, range: 820 },
      { name: 'COIL CANNON', heat: 9, damage: 61, cooldown: 1.7, range: 1150 },
      { name: 'MISSILE / 4', heat: 23, damage: 22, cooldown: 4, range: 1150 },
    ],
  },
  bastion: {
    name: 'BASTION',
    code: 'BST—95',
    role: 'ASSAULT',
    tons: 95,
    speed: 16.7,
    accel: 3.7,
    brake: 6,
    turn: 0.49,
    eye: 15.2,
    armor: 1.46,
    cooling: 0.9,
    ammo: 1.4,
    missiles: 1.45,
    jumpAccel: 22,
    jumpSpeed: 9,
    fuelUse: 43,
    fuelRegen: 13,
    jetHeat: 15,
    maxAlt: 40,
    lockTime: 1.5,
    previewScale: 1.42,
    radius: 7,
    volley: 6,
    step: 1.3,
    desc: 'Heavy armor and a siege cannon. Six-missile volleys. Slow turns and short jumps. High weapon heat.',
    weapons: [
      { name: 'HEAVY PULSE', heat: 22, damage: 50, cooldown: 1.08, range: 850 },
      { name: 'SIEGE COIL', heat: 15, damage: 94, cooldown: 2.2, range: 1250 },
      { name: 'MISSILE / 6', heat: 30, damage: 25, cooldown: 4.6, range: 1250 },
    ],
  },
};

export const chassisData = () => chassisSpecs[G.chassis];

export const compSpec = {
  head: { p: [0, 16.2, 1.7], r: 2.05, hp: 50 },
  core: { p: [0, 12, 0], r: 3.5, hp: 155 },
  leftTorso: { p: [-4.4, 15, 0], r: 2.6, hp: 85 },
  rightTorso: { p: [4.4, 15, 0], r: 2.6, hp: 85 },
  leftArm: { p: [-6.4, 10, 2], r: 2, hp: 60 },
  rightArm: { p: [6.4, 10, 2], r: 2, hp: 60 },
  leftLeg: { p: [-2.6, 4.1, 0], r: 2.0, hp: 80 },
  rightLeg: { p: [2.6, 4.1, 0], r: 2.0, hp: 80 },
};
